import * as React from "react";
import { useSelector } from "react-redux";
import { MessageBar, MessageBarType } from "@fluentui/react";

import { TEXT } from "../../../../../shared/constants/texts";

const Banner: React.FC = () => {
  const [showBanner, setShowBanner] = React.useState(true);
  const state = useSelector((state: any) => state.addToIciSlice);
  const { isAdvancePageEnabled } = state;

  return showBanner && isAdvancePageEnabled ? (
    <div className="banner-add-to-ici">
      <MessageBar
        styles={{
          root: {
            height: "auto",
            minHeight: "32px",
            width: "90vw",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          },
          content: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          },
          text: {
            fontSize: "10px",
          },
        }}
        messageBarType={MessageBarType.warning}
        isMultiline={false}
        onDismiss={() => setShowBanner(false)}
      >
        {TEXT.BANNER_MESSAGE}
      </MessageBar>
    </div>
  ) : null;
};

export default Banner;
